module.exports = __webpack_public_path__ + "static/img/br.c5a1361.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/idiomas/br.png
// module id = TAXZ
// module chunks = 0